import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {
    getAuthHeader, getPathAndQueryParams,
    objectLang,
    setErrorWindow, setLocalStorageItem
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {NoteCardClass} from "../components/NoteCardClass"
import {PathLineClass} from "../elements/PathLineClass"

export const NoteDetailPage = () => {
    setLocalStorageItem('page', 'NoteDetailPage')

    const lang = objectLang().language
    const l = lang.lang
    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()
    const [note, setNote] = useState({})
    const [owner, setOwner] = useState({})
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const noteId = useParams().id

    let host
    window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender

    const getNote = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        try {
            const data = await request(
                `${host}/api/note/detail/${noteId}`,
                'GET',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            }

            setNote(data["note"])
            setOwner(data["owner"])
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [auth, noteId, request, host])

    useEffect(() => {
        getNote().then()
    }, [getNote])

    const removeNoteHandler = () => {
        setAllowed(false)
        setDataModal({
            title: lang.modal.warnings.title,
            desc: lang.modal.warnings.desc.deleteNote,
            btnCancel: lang.modal.warnings.btnCancel,
            btnOK: lang.modal.warnings.btnOK,
            clickOK: `replaceTo /${l}/note/remove/${note["_id"]}`,
            clickCancel: 'reload'
        })
    }

    const shareHandler = async () => {
        let openCloseShare = 'closeShareLink'
        if (!note.accessLink) {
            openCloseShare = 'openShareLink'
        }
        try {
            const data = await request(`${host}/api/note/${openCloseShare}/${noteId}`, 'PUT',
                {l},
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            }
            window.location.replace(getPathAndQueryParams())
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return <ModalWin data={dataModal}/>
    }

    return (
        <>
            <PathLineClass documents={{path: note.path}}/>
            <div className={'container'}>
                <NoteCardClass
                    note={note}
                    owner={owner}
                    removeNoteHandler={removeNoteHandler}
                    shareHandler={shareHandler}
                />
            </div>
        </>

    )
}
